import axios from "axios";

import { BASE_URL } from "./api";

export async function getPartsManufacturerApprovals(payload) {
  return axios({
    method: "get",
    url: `${BASE_URL}/pma_list/${payload.endpoint}`,
    headers: {
        'Authorization': `Token ${payload.token}`
    },
  })
    .then((response) => {
      return {
        approvals: response.data.results,
        count: response.data.count,
        next: response.data.next,
        prev: response.data.previous,
        page: response.data.page,
        page_size: response.data.page_size,
        num_pages: response.data.num_pages,
      };
    })
    .catch((error) => {
      throw error;
    });
}

export async function getCompanyNameFilterChoices(payload) {
  return axios({
    method: "get",
    url: `${BASE_URL}/pma_list/get_company_name_filter_choices/`,
    headers: {
        'Authorization': `Token ${payload.token}`
    },
  })
    .then((response) => {
      return {
        company_names: response.data.company_names,
      };
    })
    .catch((error) => {
      throw error;
    });
}

// Top-level rows for the grouped view: one row per company_name, with
// pma_count + representative location + linked Company summaries.
// `endpoint` carries the same filter query string the flat list uses so
// counts reflect what's filtered for. `paginated` defaults to true.
export async function getPMACompanies(payload) {
  return axios({
    method: "get",
    url: `${BASE_URL}/pma_list/companies/${payload.endpoint}`,
    headers: {
      'Authorization': `Token ${payload.token}`
    },
  })
    .then((response) => {
      return {
        companies: response.data.results,
        count: response.data.count,
        next: response.data.next,
        prev: response.data.previous,
        page: response.data.page,
        page_size: response.data.page_size,
        num_pages: response.data.num_pages,
      };
    })
    .catch((error) => {
      throw error;
    });
}

// Distinct makes (with pma_count) for one expanded company. The same
// filter query string is appended so an active make/date/etc. filter
// narrows the list and counts under the company.
export async function getPMACompanyMakes(payload) {
  return axios({
    method: "get",
    url: `${BASE_URL}/pma_list/company_makes/${payload.endpoint}`,
    headers: {
      'Authorization': `Token ${payload.token}`
    },
  })
    .then((response) => {
      return { makes: response.data.results };
    })
    .catch((error) => {
      throw error;
    });
}

// Individual PMAs inside one (company, make) bucket. Paginated because
// a single make in a single company can still hold thousands of rows.
export async function getPMACompanyMakePMAs(payload) {
  return axios({
    method: "get",
    url: `${BASE_URL}/pma_list/company_make_pmas/${payload.endpoint}`,
    headers: {
      'Authorization': `Token ${payload.token}`
    },
  })
    .then((response) => {
      return {
        approvals: response.data.results,
        count: response.data.count,
        next: response.data.next,
        prev: response.data.previous,
        page: response.data.page,
        page_size: response.data.page_size,
        num_pages: response.data.num_pages,
      };
    })
    .catch((error) => {
      throw error;
    });
}

export async function getPMAsForCSV(filters, token) {
  // console.log('job data', jobData)
  return axios({
      method: 'get',
      url: `${BASE_URL}/pma_list/get_pmas_for_csv/${filters}`,
      headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json'
      }
  }).then((response) => {
      // console.log('response csv', response)
      return response
  }).catch(async (error) =>{
      console.log(error)
      alert(error.response.data.detail)
      return error
  })
}

// export async function createReferrer(formData, token) {
//     return axios({
//         method: 'post',
//         url: `${BASE_URL}/referrers/`,
//         headers: { 
//             'Authorization': `Token ${token}`, 
//             'Content-Type': 'application/json'
//         },
//         data: formData
//     }).then((response) => {
//         console.log(response);
//         return response
//     }).catch((error) => {
//         throw error
//     })
// }

// export async function updateReferrer(referrerId, formData, token) {
//   console.log(`${BASE_URL}/referrers/${referrerId}/`);
//   console.log(formData)
//   return axios({
//       method: 'put',
//       url: `${BASE_URL}/referrers/${referrerId}/`,
//       headers: { 
//           'Authorization': `Token ${token}`, 
//           'Content-Type': 'application/json'
//       },
//       data: formData
//   }).then((response) => {
//       return response
//   }).catch((error) => {
//       throw error
//   })
// }